module.exports = __webpack_public_path__ + "static/media/picture.4108e49b.svg";